import { useQuery } from '@tanstack/react-query';
import { getContributionYears } from '../../../services/das.service';

export const useDasContributionYears = (enabled = false) => {
  return useQuery({
    queryKey: ['dasContributionYears'],
    queryFn: getContributionYears,
    enabled,
    staleTime: 5 * 60 * 1000,
    gcTime: 10 * 60 * 1000,
    retry: 1,
  });
};
